let content = [
    {
      id: "general_trading_conditions",
      title: "Γενικοί Όροι Συναλλαγών",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Λεπτομέρειες Προϊόντος",
          content_before: `<p class="mb-5">
                        Η iFOREX Europe προσφέρει άκρως ανταγωνιστικούς όρους για τους ακόλουθους επενδυτικούς τίτλους ("Επενδυτικοί τίτλοι" ή "Τίτλοι") (i) μοχλευμένες συναλλαγές με τη χρήση περιθωρίου σε επενδυτικούς τίτλους/υποκείμενους τίτλους ("Υποκείμενοι τίτλοι"), συμπεριλαμβανομένων ζευγών νομισμάτων (Forex), εμπορευμάτων, δεικτών, μετοχών, ETF και κρυπτονομισμάτων υπο μορφή CFDs ("Μοχλευμένων τίτλων" ή "CFDs").
                        <br><br>
                        <b>Spreads</b><br>Το κόστος ανοίγματος μιας συναλλαγής ονομάζεται 'spread'. Το spread είναι η διαφορά μεταξύ της τιμής Πώλησης (Bid) και της τιμής Αγοράς (Ask). Για παράδειγμα, εάν η τιμή πώλησης του USD/JPY είναι στο 101.202 και η τιμή αγοράς του είναι στο 101.222, η διαφορά μεταξύ των δύο τιμών ονομάζεται spread. Σε αυτή την περίπτωση το spread είναι 2 pips. Εάν αποφασίσετε να κλείσετε μια συναλλαγή αμέσως μετά το άνοιγμά της και πριν από οποιαδήποτε μεταβολή των τιμών, το ποσό του spread θα αφαιρεθεί από το υπόλοιπό σας.
                        <br><br>
                        <b>Μόχλευση και Περιθώριο</b><br>Εκτός απο το γεγονός ότι το "Περιθώριο" λειτουργεί ως εγγύηση για κάλυψη τυχόν ζημιών που ενδέχεται να υποστείτε, σας επιτρέπει επίσης να κρατήσετε μια θέση πολύ μεγαλύτερη απο την πραγματική αξία του λογαριασμού σας, δίνοντας σας τη δυνατότητα να πραγματοποιήσετε μεγάλα κέρδη σε σχέση με το ποσό που επενδύσατε.
                        <br><br>
                        Η μόχλευση είναι όμως δίκοπο μαχαίρι γιατί παρόλο που μπορεί να ενισχύσει σημαντικά τα κέρδη σας, μπορεί εξίσου εύκολα να ενισχύσει τις απώλειες σας. Όταν χρησιμοποιείτε υπερβολική μόχλευση, οι χαμένες σας συναλλαγές μπορούν να αντισταθμίσουν εύκολα πολλές κερδοφόρες συναλλαγές. Οι συναλλαγές με μόχλευση εμπεριέχουν υψηλό βαθμό κινδύνου και δεν είναι κατάλληλες για όλους τους επενδυτές.
                        <br><br>
                        Ως κάτοχος λογαριασμού στην iFOREX Europe, μπαίνετε στο Πρόγραμμα Προστασίας Αρνητικού Υπολοίπου μας, πράγμα που σημαίνει ότι δε μπορείτε ποτέ να χάσετε περισσότερα απο όσα καταθέσατε. Ωστόσο, μια μικρή κίνηση της αγοράς μπορεί να οδηγήσει σε σημαντική απώλεια κεφαλαίων. Η Πλατφόρμα Συναλλαγών μας υπολογίζει αυτόματα το διαθέσιμο περιθώριο σας πριν απο την εκτέλεση όποιασδήποτε εντολής, και ελέγχει τα διαθέσιμα σας κεφάλαια πρίν απο κάθε αίτημα σας για ανάληψη κεφαλαίων.
                        <br><br>
                        Οι απαιτήσεις περιθωρίου σχετίζονται κυρίως με την αύξηση Έκθεσης στο λογαριασμό σας, που προκύπτει είτε λόγω ανοίγματος/κλεισίματος θέσεων είτε λόγω αιτήματος για ανάληψη κεφαλαίων ενώ υπάρχουν ανοικτές θέσεις.
                          </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/trading-conditions/currencies">Νομίσματα</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/commodities">Εμπορεύματα</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/indices">Δείκτες</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/shares">Μετοχές</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/etfs">ETFs</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/crypto">Κρυπτονομίσματα</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Ωράριο Συναλλαγών",
          content_before: `<p>
          Κατά τη διάρκεια του χειμώνα στην Ευρώπη και τη Βόρεια Αμερική, η εβδομαδιαία δραστηριότητα αρχίζει την Κυριακή στις 22:05 GMT μέχρι και την Παρασκευή, στις 21:00 GMT. Με την έναρξη της θερινής ώρας σε αυτές τις περιοχές, η εβδομαδιαία δραστηριότητα της αγοράς ξεκινά την Κυριακή στις 21:05 GMT και τελειώνει την Παρασκευή στις 20:00. Οι ώρες δραστηριότητας στην αγορά μπορεί να ποικίλουν λόγω των επίσημων αργιών ή λόγω ασυνήθιστων συνθηκών ρευστότητας που ενδέχεται να προκύψουν από ακραία παγκόσμια γεγονότα. Οι ώρες ανοίγματος ή κλεισίματος μπορεί επίσης να αλλάξουν από την iFOREX Europe για λόγους ρευστότητας και διαχείρισης κινδύνου
              <br><br>
              Παρόλο που οι περισσότεροι επενδυτικοί τίτλοι είναι διαπραγματεύσιμοι όλο το 24ωρο χωρίς διακοπή, ορισμένοι τίτλοι έχουν ειδικά ωράρια συναλλαγών όπως αυτά φαίνονται στον πιο κάτω πίνακα:
              </p>`,
  
          data_id: "TradingHours",
          products: {
            1:"Νομίσματα & Κρύπτο",
            2:"Εμπορεύματα",
            3:"Δείκτες",
            4:"Μετοχές",
            5:"Precious Metals Spot",
            8:"ETFs"
          },
          table_titles: [
            "Market",
            "Ωράριο Συναλλαγών (GMT)",
            "1ο Ημερήσιο Διάλειμμα Ώρα (GMT)",
            "2ο Ημερήσιο Διάλειμμα Ώρα (GMT)",
            "Έγκυρα Μέχρι (GMT)"
          ],
          content_after: `<p>Δεν είστε σίγουροι ποια Αγορά περιλαμβάνει το προϊόν που ψάχνετε; Κάντε κλικ εδώ για να δείτε την πλήρη <span class="tclink" target-tab="tc-view-6">λίστα επενδυτικών τίτλων</span> ανά αγορά.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Αργίες",
          content_before: `<p>
          Για να επιβεβαιώσουμε ότι είστε ενήμεροι για τα ωράρια της αγοράς και για όλες τις αργίες, παρακαλούμε δείτε παρακάτω μια λίστα με τα γεγονότα που θα μπορούσαν να αλλάξουν το ωράριο συναλλαγών.<br>
          Στην iFOREX Europe καταβάλλουμε κάθε δυνατή προσπάθεια για να ανανεώνουμε αυτές τις πληροφορίες.<br>
          Εάν επιθυμείτε να λάβετε περισσότερες πληροφορίες παρακαλούμε μη διστάσετε να επικοινωνήσετε με το dealing desk μας.
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Market",
            "Πάυση Συναλλαγών στις (GMT)",
            "Συνέχεια Συναλλαγών στις (GMT)",
          ],
          content_after: `<p class="mt-4">Δεν είστε σίγουροι ποια Αγορά περιλαμβάνει το προϊόν που ψάχνετε; Κάντε κλικ εδώ για να δείτε την πλήρη <span class="tclink" target-tab="tc-view-6">λίστα επενδυτικών τίτλων</span> ανά αγορά.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Ενολές και Εκτέλεση",
          content_before: `<p><b>Τύποι Εντολών</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>ΕΝΤΟΛΕΣ MARKET</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Άνοιγμα Συναλλαγής</td>
                   <td>Μια εντολή για άνοιγμα θέσης στην τιμή που επικρατει στην αγορά</td>
                </tr>
                <tr>
                   <td>Κλείσιμο Συναλλαγής</td>
                   <td>Μια εντολή για κλείσιμο θέσης στην τιμή που επικρατει στην αγορά</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>ΕΝΤΟΛΕΣ ΟΡΙΟΥ</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Stop Loss</td>
                   <td>Το Stop Loss είναι μια εντολή για άνοιγμα ή κλείσιμο συναλλαγής σε τιμή χειρότερη από την τρέχουσα τιμή της αγοράς.</td>
                </tr>
                <tr>
                   <td>Take Profit</td>
                   <td>Το Take Profit είναι μια εντολή για άνοιγμα ή κλείσιμο συναλλαγής σε τιμή καλύτερη από την τρέχουσα τιμή της αγοράς.</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>Εντολές Market</b><br>Οι εντολές Market (αιτήματα για συναλλαγές, π.χ. Ανοιγμα Θέσης, Κλείσιμο Θέσης) εκτελούνται στην τιμή που βρίσκεται στην Πλατφόρμα Συναλλαγών Της Εταιρείας (απο την πλευρά του πελάτη) κατά την ακριβή στιγμή της εκτέλεσης, υπό την προϋπόθεση ότι η εν λόγω τιμή βρίσκεται μέσα σε ένα προκαθορισμένο επίπεδο ανοχής από το υποκείμενη τιμή όπως αυτή ανανεώνεται στους servers της Εταιρίας και ανεξάρτητα αν η υποκείμενη τιμή είναι πάνω ή κάτω από την τιμή όπως αυτή αναγράφεται στην Πλατφόρμα Συναλλαγών (Παίρνετε Αυτό Που Βλέπετε, ή WYSIWYG). Σε περίπτωση που η τιμή που φαίνεται στην πλατφόρμα συναλλαγών (από την πλευρά του πελάτη) υπερβαίνει το ανωτέρω όριο ανοχής, για παράδειγμα, λόγω διακυμάνσεων του υποκείμενου τίτλου μεταξύ της στιγμής που ο πελάτης θέτει την εντολή του και της στιγμής που αυτή έχει ληφθεί και έχει εκτελεστεί, ή λόγω υψηλής μεταβλητότητας της αγοράς και καθυστερημένης επικοινωνίας δεδομένων, η Εντολή θα εκτελεστεί στην τιμή η οποία αναγράφεται στους servers της Εταιρείας, η οποία θα είναι διαφορετική απο την τιμή που αναγράφεται στην Πλατφόρμα Συναλλαγών της Εταιρείας (Market Price), σε μια συμμετρική βάση. Στην περίπτωση σημαντικής διαφοράς μεταξύ της τιμής που αναγράφεται στην Πλάτφόρμα Συναλλαγών (απο την πλευρά του πελάτη) και της τιμής που αναγράφεται στους servers της Εταιρείας, η Εντολή θα απορρίπτεται.
          </p>
          <p>
             <b>Εντολές Ορίου</b><br>Οι εντολές ορίων (μελλοντικές εντολές) εκτελούνται στην τιμή αγοράς όπως αυτή αναγράφεται στους servers της εταιρείας, η οποία μπορεί να είναι διαφορετική από την τιμή που αναφέρεται στην εντολή ("Slippage"). Το Slippage μπορεί να προκύψει σε περίπτωση όπου η τιμή που αναφέρεται στην εντολή δεν είναι διαθέσιμη στους servers, για παράδειγμα λόγω υψηλής μεταβλητότητας και λόγω κενών στις τιμές της αγοράς. Σε αυτή την περίπτωση, η εντολή θα εκτελείται στην πρώτη διαθέσιμη τιμή, ανεξάρτητα από την κατεύθυνση του Slippage, είτε αυτό υπέρ του πελάτη είτε όχι, με ένα συμμετρικό και διαφανή τρόπο (Συμμετρικό Slippage).<br><br>Οι επενδυτικοί τίτλοι οι οποίοι δεν είναι διαθέσιμοι για συναλλαγές επι 24ωρης βάσης (π.χ. μετοχές και δείκτες), μπορεί να παρουσιάσουν κενά επι καθημερινής βάσεως και ως εκ τούτου, είναι πιο επιρρεπείς σε slippage. Είναι σημαντικό να σημειώσετε ότι το Slippage δεν επηρεάζει το Πρόγραμμα Προστασίας Αρνητικού Υπολοίπου, έτσι ο Πελάτης δεν πρόκειται ποτέ να χάσει περισσότερα απο το ποσό το οποίο έχει επενδύσει (συμπεριλαμβανομένου κάθε πιθανού κέρδους), ακόμη και σε περιπτώσεις όπου προκύπτει slippage.<br><br>Παρακαλούμε σημειώστε: Σε περίπτωση που ο πελάτης έχει ορίσει μια Εντολή Ορίου σε ανοικτή/ές συναλλαγή/ές του, ορισμένες ή όλες οι εν λόγω συναλλαγές μπορεί να κλείσουν αυτόματα πριν να φθάσουν στα αντίστοιχα επίπεδα των εντολών ορίου τους, λόγω του υποχρεωτικού κανόνα περιθωρίου εκκαθάρισης. Για περισσότερες πληροφορίες σχετικά με το υποχρεωτικό περιθώριο εκκαθάρισης, ανατρέξτε στην πιο κάτω ενότητα "Πληροφορίες περιθωρίου".
          </p>
          <p>
             <b>Καθυστέρηση Εκτέλεσης</b><br>Καθυστέρηση στην εκτέλεση μιας συναλλαγής μπορεί να συμβεί για διάφορους λόγους, όπως τεχνικά θέματα σύνδεσης στο διαδίκτυο απο πλευράς του Πελάτη, προβλήματα με το κινητό ή με άλλο μέσο επικοινωνίας με τους server της iFOREX Europe, κάτι το οποίο μπορεί να οδηγήσει σε εκκρεμούσες εντολές "hanging orders". Μια διαταραχή σύνδεσης μπορεί μερικές φορές να διακόψει την επικοινωνία και να απενεργοποιήσει την πλατφόρμα προκαλώντας καθυστερήσεις στην μετάδοση των δεδομένων μεταξύ της πλατφόρμας του επενδυτή και του server της iFOREX Europe.
          </p>
          <p>
             <b>Εκκρεμούσες Εντολές "Hanging Orders"</b><br>Κατά τη διάρκεια περιόδων με μεγάλο όγκο συναλλαγών ή καθυστέρηση επικοινωνίας δεδομένων, μπορεί να προκύψουν εκκρεμούσες εντολές (δημιουργείται μια σειρά απο Εντολές Ορίων). Αυτή η αύξηση εισερχόμενων εντολών μπορεί μερικές φορές να προκαλέσει καθυστέρηση στην επιβεβαίωση/επεξεργασία ορισμένων εντολών ορίων. Σε ορισμένες περιπτώσεις, η θέση μπορεί στην πραγματικότητα να έχει εκτελεστεί και η καθυστέρηση να είναι απλά στην οθόνη του πελάτη, λόγω μεγάλης κυκλοφορίας δεδομένων διαδίκτυου.<br><br>Λάβετε υπόψη ότι πρέπει να τοποθετείται μια εντολή κάθε φορά. Πολλαπλές καταχωρήσεις για την ίδια εντολή μπορεί να επιβραδύνουν ή και να κλειδώσουν τον υπολογιστή σας ή να οδηγήσουν σε άνοιγμα ανεπιθύνητων θέσεων.
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Προστασία Αρνητικού Υπολοίπου",
          content_before: `<p>
                          Το πρόγραμμα Προστασίας Αρνητικού Υπολοίπου της iFOREX Europe εγγυάται ότι οι ζημίες του πελάτη περιορίζονται στα κεφάλαια που επενδύονται στον λογαριασμό του πελάτη. Σύμφωνα με την πολιτική αυτή, ο πελάτης δεν πρέπει ποτέ να έχει χρεωστικό υπόλοιπο λόγω απωλειών απο τις συναλλαγές του με την iFOREX Europe και όποιαδήποτε πιθανή απώλεια του πελάτη θα πρέπει να περιορίζεται στο ποσό που κατατέθηκε στο λογαριασμό του Πελάτη και στα επιπρόσθετα κέρδη τα οποία έχουν αποκτηθεί από τον πελάτη, αν αυτά υπάρχουν.
                            </p>`,
          data_id: "",
          content_after: "",
        },
        {
  //id: "margin_information",
  id: "tc-view-24",
  title: "Πληροφορίες Περιθωρίου",
  content_before: `
    <p>
      Το παράθυρο που εμφανίζεται παρακάτω παρέχει λεπτομερείς πληροφορίες σχετικά με το περιθώριο ενός λογαριασμού:
      <div class="table-wrapper">
        <table class="table3 mt-4 mb-4">
          <tbody>
            <tr>
              <td>Ίδια Κεφάλαια</td>
              <td>€4,995</td>
            </tr>
            <tr>
              <td>Χρησιμοποιημένο Περιθώριο</td>
              <td>€2,500</td>
            </tr>
            <tr>
              <td>Διαθέσιμο Περιθώριο</td>
              <td>€2,495</td>
            </tr>
            <tr>
              <td>Χρήση Περιθωρίου</td>
              <td style="color:green">50.05%</td>
            </tr>
            <tr>
              <td>Περιθώριο Συντήρησης</td>
              <td>€1,250</td>
            </tr>
            <tr>
              <td>Καθαρή Έκθεση</td>
              <td>€250,000</td>
            </tr>
            <tr>
              <td>Κάλυψη Έκθεσης</td>
              <td>1.50%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="list-style-disc-small mb-3">
        <li>
          Τα <b>Ίδια Κεφάλαια</b> αντικατοπτρίζουν την τρέχουσα αξία του λογαριασμού σας. Περιλαμβάνουν το Υπόλοιπο, τα Κέρδη/Ζημίες από ανοικτές θέσεις.
        </li>

        <li>
          Το <b>Χρησιμοποιημένο Περιθώριο</b> δείχνει το ποσό των Ιδίων Κεφαλαίων σε έναν λογαριασμό που χρησιμοποιείται επί του παρόντος ως Περιθώριο για τις Ανοικτές σας Συναλλαγές. Σε περίπτωση που το Χρησιμοποιημένο Περιθώριο είναι ίσο ή μεγαλύτερο από τα Ίδια Κεφάλαια, αυτό υποδεικνύει ότι η μόχλευση του λογαριασμού έχει μεγιστοποιηθεί.
        </li>

        <li>
          Το <b>Διαθέσιμο Περιθώριο</b> δείχνει το ποσό των Ιδίων Κεφαλαίων σε έναν λογαριασμό που δεν χρησιμοποιείται επί του παρόντος και είναι διαθέσιμο για περαιτέρω αύξηση της καθαρής έκθεσης. Σε περίπτωση που το Διαθέσιμο Περιθώριο είναι μηδέν, αυτό υποδεικνύει μέγιστη χρήση μόχλευσης στον λογαριασμό.<br>
          Διαθέσιμο Περιθώριο = Ίδια Κεφάλαια – Χρησιμοποιημένο Περιθώριο
        </li>

        <li>
          Η <b>Χρήση Περιθωρίου</b> δείχνει το ποσοστό των Ιδίων Κεφαλαίων που χρησιμοποιούνται ως Περιθώριο για τις τρέχουσες Ανοικτές Συναλλαγές του λογαριασμού. Χρήση Περιθωρίου 100% και άνω υποδεικνύει μέγιστη χρήση μόχλευσης στον λογαριασμό.<br>
          Χρήση Περιθωρίου % = (Χρησιμοποιημένο Περιθώριο / Ίδια Κεφάλαια) x 100
        </li>

        <li>
          Το <b>Περιθώριο Συντήρησης</b> είναι ίσο με το 50% του Χρησιμοποιημένου Περιθωρίου που απαιτείται για τη διατήρηση των ανοικτών συναλλαγών σας. Εάν τα Ίδια Κεφάλαια πέσουν σε ή κάτω από αυτό το επίπεδο, θα ενεργοποιηθεί αυτόματα η Προστασία Κλεισίματος λόγω Περιθωρίου (όπως ορίζεται παρακάτω).<br>
          Περιθώριο Συντήρησης = Χρησιμοποιημένο Περιθώριο x 0.5
        </li>

        <li>
          Η <b>Κάλυψη Έκθεσης</b> είναι το ποσοστό της έκθεσης που καλύπτεται από κεφάλαια. Αντικατοπτρίζει τη μέγιστη αλλαγή στην τιμή της αγοράς ενάντια στην κατεύθυνση των ανοικτών συναλλαγών, που υποστηρίζονται από κεφάλαια (έως ότου επιτευχθεί το Περιθώριο Συντήρησης).<br>
          Κάλυψη Έκθεσης = (Ίδια Κεφάλαια - Περιθώριο Συντήρησης) / Καθαρή Έκθεση
        </li>
      </ul>

      <b>Προστασία Κλεισίματος λόγω Περιθωρίου</b><br>
      Εάν τα διαθέσιμα κεφάλαια στα Ίδια Κεφάλαια ενός πελάτη είναι ίσα ή πέσουν κάτω από το Περιθώριο Συντήρησης, η iFOREX Europe θα κλείσει αυτόματα τη συναλλαγή που καταναλώνει το μεγαλύτερο ποσό Χρησιμοποιημένου Περιθωρίου, προκειμένου να επιτευχθεί το χαμηλότερο δυνατό Περιθώριο Συντήρησης (κλείνοντας μόνο Ανοικτές Συναλλαγές σε τίτλους που είναι ανοιχτοί εκείνη τη στιγμή σύμφωνα με τις δημοσιευμένες ώρες διαπραγμάτευσης). Εάν δεν υπάρχουν Ανοικτές Συναλλαγές εκείνη τη στιγμή, η συναλλαγή στον τίτλο που λαμβάνει πρώτος τιμή θα κλείσει πρώτη. Όπου υπάρχουν πολλαπλές συναλλαγές (περισσότερες από μία) που καταναλώνουν εξίσου το μεγαλύτερο ποσό Χρησιμοποιημένου Περιθωρίου, η Εταιρεία θα κλείσει αυτόματα τη συναλλαγή που άνοιξε πρώτη. Σε περίπτωση που το χαμηλότερο δυνατό Περιθώριο Συντήρησης δεν μπορεί να επιτευχθεί με το αυτόματο κλείσιμο μίας μόνο συναλλαγής, η Εταιρεία θα κλείσει όλες τις Ανοικτές Συναλλαγές σε ένα συγκεκριμένο τίτλο. Η iFOREX Europe επιτρέπει στους πελάτες την πλήρη χρήση μη πραγματοποιημένων κερδών από τις Ανοικτές τους Συναλλαγές, για να υποστηρίξουν τις ζημιογόνες τους συναλλαγές.
      <br><br>

      <b><u><u>Παραδείγματα</u></u></b><br><br>

      <b>Παράδειγμα I</b><br>
      Ο πελάτης διατηρεί πολλαπλές ανοιχτές συναλλαγές και τα Ίδια Κεφάλαια του λογαριασμού φτάνουν σε επίπεδο ίσο ή κάτω από το Περιθώριο Συντήρησης:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Ανοιχτές Συναλλαγές:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>1 συναλλαγή EUR/USD: ΑΓΟΡΑ €60.000 @ 1,1750 (Αρχικό Απαιτούμενο Περιθώριο = 3,33% x €60.000 = €1.998)</li>
          <li>1 συναλλαγή Germany 40: ΑΓΟΡΑ 4 συμβόλαια @ 12.500 (Αρχικό Απαιτούμενο Περιθώριο = 5% x 4 x €12.500 = €2.500)</li>
          <li>1 συναλλαγή WTI Oil: ΑΓΟΡΑ 500 βαρέλια @ 70,00 ή 59,56 το βαρέλι όταν η αξία είναι σε ευρώ (Αρχικό Απαιτούμενο Περιθώριο = 10% x 500 x €59,56 = €2.978)</li>
        </ul>
        <li>Χρησιμοποιημένο Περιθώριο = €1.998 + €2.500 + €2.978 = €7.476</li>
        <li>Επίπεδο Περιθωρίου Συντήρησης = €3.738</li>
      </ul>
      Μόλις τα Ίδια Κεφάλαια του λογαριασμού φτάσουν σε ή κάτω από €3.738, ενεργοποιείται η Προστασία Κλεισίματος Περιθωρίου κλείνοντας τη συναλλαγή με το μεγαλύτερο Χρησιμοποιημένο Περιθώριο, δηλαδή την <b>ΑΓΟΡΑ 500 βαρελιών WTI Oil</b>.
      <br><br>

      <b>Παράδειγμα II</b><br>
      Ο πελάτης διατηρεί πολλαπλές ανοιχτές συναλλαγές και τα Ίδια Κεφάλαια φτάνουν σε επίπεδο ίσο ή κάτω από το Περιθώριο Συντήρησης:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Ανοιχτές Συναλλαγές:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>2 συναλλαγές USD/JPY: ΑΓΟΡΑ $100.000 (Αρχικό Απαιτούμενο Περιθώριο = 3,33% x $100.000 = $3.330), ΠΩΛΗΣΗ $80.000 (Αρχικό Απαιτούμενο Περιθώριο = 3,33% x $80.000 = $2.664)</li>
          <li>1 συναλλαγή USD/PLN : ΠΩΛΗΣΗ $80.000 (Αρχικό Απαιτούμενο Περιθώριο = 5% x $80.000 = $4.000)</li>
        </ul>
        <li>Χρησιμοποιημένο Περιθώριο = ($3.330 – $2.664) + $4.000 = $4.666</li>
        <li>Επίπεδο Περιθωρίου Συντήρησης = $2.333</li>
      </ul>
      Μόλις τα Ίδια Κεφάλαια φτάσουν σε ή κάτω από $2.333, ενεργοποιείται η Προστασία Κλεισίματος Περιθωρίου κλείνοντας τη συναλλαγή με το μεγαλύτερο Χρησιμοποιημένο Περιθώριο, δηλαδή την <b>ΠΩΛΗΣΗ $80.000 USD/PLN</b>.
      <br><br>
      Σημείωση:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Το κλείσιμο της ΠΩΛΗΣΗΣ $80.000 USD/JPY θα αύξανε την Καθαρή Έκθεση σε USD/JPY από $20.000 σε $100.000, άρα το <b>Χρησιμοποιημένο Περιθώριο θα αυξανόταν κατά $2.664 ⇾</b> ($100.000 x 3,33%) − ($20.000 x 3,33%) = $3.330 − $666 = <u>+$2.664</u></li>
        <li>Το κλείσιμο της ΑΓΟΡΑΣ $100.000 USD/JPY θα αύξανε την Καθαρή Έκθεση σε USD/JPY από $20.000 σε $80.000, άρα το <b>Χρησιμοποιημένο Περιθώριο θα αυξανόταν κατά $1.998 ⇾</b> ($80.000 x 3,33%) − ($20.000 x 3,33%) = $2.664 − $666 = <u>+$1.998</u></li>
        <li>Το κλείσιμο της ΠΩΛΗΣΗΣ $80.000 USD/TRY θα μείωνε την Καθαρή Έκθεση σε USD/TRY από $80.000 σε 0, άρα το <b>Χρησιμοποιημένο Περιθώριο θα μειωνόταν κατά $4.000</b></li>
      </ul>

      <b>Παράδειγμα III</b><br>
      Ο πελάτης διατηρεί πολλαπλές Ανοιχτές Συναλλαγές, ωστόσο το χαμηλότερο δυνατό Περιθώριο Συντήρησης δεν μπορεί να επιτευχθεί με αυτόματο κλείσιμο μίας μόνο συναλλαγής:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Ανοιχτές Συναλλαγές:</li>
        <ul class="list-style-disc-small empty-disc ml-4">
          <li>3 συναλλαγές USD/JPY: ΑΓΟΡΑ $100.000 (Αρχικό Απαιτούμενο Περιθώριο = 3,33% x $100.000 = $3.330), ΠΩΛΗΣΗ $70.000 (Αρχικό Απαιτούμενο Περιθώριο = 3,33% x $70.000 = $2.331), ΠΩΛΗΣΗ $10.000 (Αρχικό Απαιτούμενο Περιθώριο = 3,33% x $10.000 = $333).</li>
          <li>2 συναλλαγές USD/PLN: ΠΩΛΗΣΗ $10.000 (Αρχικό Απαιτούμενο Περιθώριο = 5% x $10.000 = $500), ΑΓΟΡΑ $8.000 (Αρχικό Απαιτούμενο Περιθώριο = 5% x $8.000 = $400)</li>
          <li>2 συναλλαγές USD/INR: ΠΩΛΗΣΗ $10.000 (Αρχικό Απαιτούμενο Περιθώριο = 5% x $10.000 = $500), ΑΓΟΡΑ $7.000 (Αρχικό Απαιτούμενο Περιθώριο = 5% x $7.000 = $350)</li>
        </ul>
        <li>Χρησιμοποιημένο Περιθώριο = ($3.330 – $2.331 – $333) + ($500 − $400) + ($500 − $350) = $916</li>
        <li>Επίπεδο Περιθωρίου Συντήρησης = $458</li>
      </ul>
      Σε αυτή την περίπτωση, μόλις τα Ίδια Κεφάλαια φτάσουν σε ή κάτω από $458, οι συναλλαγές στον λογαριασμό θα κλείσουν αυτόματα σε επίπεδο μέσου, βάσει του μέσου με την υψηλότερη Καθαρή Έκθεση. Συνεπώς, <b>όλες οι συναλλαγές USD/JPY</b> θα κλείσουν.
      <br><br>
      Σημείωση:<br><br>
      <ul class="list-style-disc-small mb-3">
        <li>Το κλείσιμο οποιασδήποτε συναλλαγής θα αύξανε την Καθαρή Έκθεση και συνεπώς το <b>Χρησιμοποιημένο Περιθώριο</b>.</li>
        <li>Το κλείσιμο όλων των συναλλαγών USD/JPY θα μείωνε την Καθαρή Έκθεση κατά $20.000 και έτσι το <b>Χρησιμοποιημένο Περιθώριο θα μειωνόταν κατά $666</b>, που είναι μεγαλύτερη μείωση από το κλείσιμο συναλλαγών USD/PLN (μείωση $100) ή USD/INR(μείωση $150).</li>
      </ul>
    </p>
  `,
  data_id: "",
  content_after: ""
}
,
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "Επιπρόσθετοι Κανόνες Συναλλαγών",
          content_before: `
              <p>
              <b>Μέγιστη Έκθεση</b><br>
              Ως προληπτικό μέτρο με στόχο την καλύτερη διαχείριση των κινδύνων και την αποφυγή της υπερβολικής έκθεσης σε ένα μεμονωμένο πελάτη, η iFOREX Europe έχει ορίσει ένα περιορισμό μέγιστης καθαρής έκθεσης μέχρι 12 (δώδεκα) εκατομμύρια Ευρώ ανά πελάτη. Η iFOREX Europe είχε ορίσει επίσης μέγιστη καθαρή έκθεση ανά επενδυτικό τίτλο. Για να δείτε τη μέγιστη καθαρή έκθεση ανά επενδυτικό τίτλο, <span class="tclink" target-tab="tc-view-6" target-section="product_section">κάντε κλικ</span>. εδώ. Η iFOREX Europe έχει το δικαίωμα, κατά την απόλυτη διακριτική της ευχέρεια να ακυρώσει ή να αλλάξει αυτό τον περιορισμό σε όποιαδήποτε στιγμή, χωρίς καμία προηγούμενη ειδοποίηση.
              <br><br>
              <b>Αντιστάθμιση Κινδύνου "Hedging"</b><br>
              Το "hedging" ορίζεται ως το άνοιγμα των δύο θέσεων στο ίδιο προϊόν ή υποκείμενο τίτλο αλλά σε διαφορετικές κατευθύνσεις (μια θέση "αγοράς" και μια θέση "πώλησης"), ανεξαρτήτως αν ανοίγονται την ίδια στιγμή ή αν είναι του ίδιου μεγέθους. Η iFOREX Europe λαμβάνει υπόψη τις συναλλαγές hedging για τον υπολογισμό του ελάχιστου περιθωρίου σε σωρευτική βάση ή σε "καθαρή" βάση. Επιπλέον, η iFOREX Europe θεωρεί το κλείσιμο μιας συναλλαγής hedging, ως το άνοιγμα μιας νέας συναλλαγής, η οποία ισούται με το μέγεθος της εναπομείνοντος συναλλαγής.
              <br><br>
              <b>Κλείσιμο Συναλλαγών "Netting"</b><br>
              Στην περίπτωση όπου περισσότερες από μία θέσεις πρέπει να κλείσουν ταυτόχρονα σε έναν λογαριασμό, η iFOREX Europe θα κλείσει όλες τις ανοικτές θέσεις σαν σύνολο.<br>Ο αριθμός συναλλαγής που αποδίδεται σε κάθε κλειστή θέση ρυθμίζεται με βάση τους κανόνες FIFO. Αυτό σημαίνει ότι μετά το κλείσιμο των θέσεων, η πρώτη θέση που ανοίχθηκε θα λάβει το χαμηλότερο αριθμό συναλλαγής και η τελευταία θέση που ανοίχθηκε θα λάβει το μεγαλύτερο αριθμό συναλλαγής.
              <br><br>
              <b>Μη Εξουσιοδοτημένες Πρακτικές Συναλλαγών</b><br>
              Η iFOREX Europe υποστηρίζει την εντιμότητα των συναλλαγών και δεν επιτρέπει πρακτικές οι οποίες ασκούν καταχρηστικές μεθόδους συναλλαγών, όπως οι συναλλαγές υπο συνθήκες καθυστερημένης επικοινωνίας δεδομένων, χειραγώγηση τιμών, χειραγώγηση του χρόνου διαπραγμάτευσης ή οποιεσδήποτε άλλες πρακτικές που θεωρούνται παράνομες και/ή χρησιμοποιούνται για να δημιουργήσουν ένα αθέμιτο πλεονέκτημα. Παραδείγματα τέτοιων απαγορευμένων πρακτικών μπορούν να είναι, χωρίς περιορισμούς, όποιαδήποτε απο τα ακόλουθα:
              <ul class="list-style-disc-small mt-3 mb-2">
                 <li>
                    <b>Το Scalping</b> είναι μια στρατηγική συναλλαγών που αποσκοπεί στην εκμετάλλευση μικρών μεταβολών στις τιμές. Οι επενδυτές που εφαρμόζουν αυτή τη στρατηγική ανοίγουν πολλές βραχυπρόθεσμες συναλλαγές, τις οποίες συνήθως κλείνουν μέσα σε μερικά δευτερόλεπτα ή λεπτά.
                 </li>
                 <li>
                    <b>Αυτοματισμός</b> (π.χ. ΕΑ) ή αλγορυθμικές συναλλαγές είναι η χρήση ηλεκτρονικών πλατφόρμων για την εισαγωγή εντολών με έναν αλγόριθμο που να εκτελεί προγραμματισμένες οδηγίες συναλλαγών, όπου οι μεταβλητές μπορεί να περιλαμβάνουν χρονοδιάγραμμα, τιμή, ή μέγεθος εντολής και σε πολλές περιπτώσεις η ενεργοποίηση της εντολής γίνεται απο "ρομπότ", χωρίς καμία ανθρώπινη παρέμβαση.
                 </li>
                 <li>
                    <b>Το "API trading"</b> είναι μια επιφάνεια προγραμματισμού εφαρμογών η οποία σχετίζεται με συναλλαγές που χρησιμοποιούν λογισμικό μέσω του οποίου επικοινωνούν με άλλα προγράμματα. Το API ενεργεί ως μεσάζων μεταξύ του επενδυτή και της αγοράς, επανατοποθετόντας εντολές και ανακτώντας πληροφοριες, όπου απαιτείται.
                 </li>
                 <li>
                    Οι <b>"Πολλαπλοί λογαριασμοί"</b> αναφέρονται σε δύο ή περισσότερους λογαριασμούς οι οποίοι έχουν δημιουργηθεί από έναν πελάτη, προκειμένου να λάβει τα πολλαπλά οφέλη που παρέχονται από την iFOREX Europe.
                 </li>
              </ul>
              <p>Όταν η Εταιρεία έχει οποιαδήποτε ένδειξη ή υποψία, κατά την αποκλειστική και απόλυτη διακριτική της ευχέρεια, για οποιαδήποτε μορφή εκμετάλλευσης, παράνομων, αθέμιτων, μη εξουσιοδοτημένων ή/και καταχρηστικών επενδυτικών πρακτικών, που χρησιμοποιούνται για να δώσουν στον πελάτη κάποιο αθέμιτο πλεονέκτημα, είτε για απάτη, χειραγώγηση ή παραβίαση των συμφωνιών, των πολιτικών της Εταιρείας, των όρων και προϋποθέσεων, η Εταιρεία έχει το δικαίωμα, κατά την αποκλειστική και απόλυτη διακριτική της ευχέρεια και χωρίς να θίγει τα δικαιώματά της βάσει των συμφωνιών της με τον πελάτη και της ισχύουσας νομοθεσίας, να ακυρώσει όλες τις συναλλαγές που διενεργήθηκαν στους σχετικούς λογαριασμούς, συμπεριλαμβανομένων όλων των κερδών ή ζημιών που προέκυψαν από αυτούς ή/και να μπλοκάρει τον εν λόγω λογαριασμό.</p>
              <b>Σφάλμα Τιμών</b><br>
              Η Τεχνολογία διαδικτυακών συναλλαγών δεν είναι τέλεια και σε σπάνιες περιπτώσεις, η τροφοδοσία τιμών μπορεί να διακοπεί. Αυτό μπορεί να διαρκέσει μόνο για μια στιγμή, αλλά όταν συμβεί, οι τιμές μπορεί να επηρεαστούν. Ενώ μπορεί να είναι δελεαστικό να τοποθετήσετε μια "συναλλαγή αρμπιτράζ", να έχετε κατά νου ότι οι τιμές δεν αντανακλούν την πραγματική τιμή της αγοράς και η συναλλαγή σας μπορεί να εκτελεστεί αρκετά pips μακρυά από την τιμή που αναγράφεται. Στην περίπτωση όπου συναλλαγές εκτελούνται σε τιμές που δεν προσφέρονται από την iFOREX Europe, η iFOREX Europe διατηρεί το δικαίωμα να αντιστρέψει αυτές τις συναλλαγές, καθώς δεν θεωρούνται ως έγκυρες. Λάβετε υπόψη ότι αυτές οι περιπτώσεις είναι συνήθως σπάνιες, και με την αποχή απο τις συναλλαγές κατά τη διάρκεια αυτών των ενδεχομένων, οι έπενδυτές μπορούν να αποφύγουν τον κίνδυνο που συνδέεται με τα παραπάνω σενάρια.
              <br><br>
              <b>Τέλη Συντήρησης</b><br>
              Οι Λογαριασμοί πελατών στους οποίους δεν υπήρξε ποτέ καμία επενδυτική δραστηριότητα για χρονικό διάστημα δώδεκα (12) συνεχόμενων μήνών, θα χρεώνεται με ένα τριμηνιαίο τέλος συντήρησης $ 15 δολαρίων ή με το σύνολο του κεφαλαίου του λογαριασμού εαν αυτό είναι χαμηλότερο απο $ 15 δολάρια.<br>Αν ο πελάτης δεν έχει διαθέσιμα κεφάλαια στον λογαριασμό του, η iFOREX Europe δεν θα υποβάλει καμοία χρέωση τελών συντήρησης.
              <br><br>
              Για περισσότερες πληροφορίες σχετικά με τις συναλλαγές, δείτε τους <a href="/legal/client-agreement.pdf">Όρους και Προϋποθέσεις</a> μας.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Forex",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Ολονύκτια Χρηματοδότηση",
          content_before: `
                  <p>Όταν κάνετε συναλλαγές με μόχλευση σε Forex και CFDs με την iFOREX Europe, οι θέσεις που ανοίγετε υπόκεινται σε ολονύκτια χρηματοδότηση στο τέλος κάθε ημέρας. Αυτή η ολονύκτια χρηματοδότηση μπορεί να αφορά πίστωση ή χρέωση, η οποία υπολογίζεται βάσει των σχετικών επιτοκίων του νομίσματος στο οποίο συναλλάσεται ο υποκείμενος τίτλος, με μια επιπλέον προσαύξηση. Η προσαύξηση "mark-up" για τα ζεύγη νομισμάτων ξεκινά απο 0.75% και μπορεί να είναι υψηλότερη ή να διαφέρει μεταξύ θέσεων αγοράς και θέσεων πώλησης. Παρακαλούμε ανατρέξτε στον παρακάτω πίνακα για τα τελευταία επίπεδα ολονύκτιας χρηματοδότησης.
                  <br><br>
                  Εαν το αποτέλεσμα του υπολογισμού της ολονύκτιας χρηματοδότησης είναι θετικό αυτό σημαίνει ότι ένα συγκεκριμένο ποσό θα πιστωθεί στο υπόλοιπο του λογαριασμού σας. Μια αρνητική ολονύκτια χρηματοδότηση σημαίνει ότι ένα συγκεκριμένο ποσό θα αφαιρεθεί απο το υπόλοιπο του λογαριασμού σας.
                  <br><br>
                  Μπορείτε να βρείτε τα ποσοστά, τα ποσά και τα σχετικά ωράρια των ολονύκτιων χρηματοδοτήσεων τόσο στο παράθυρο "Νέας συναλλαγής" όσο και στο παράθυρο "Εντολής Ορίου", στην ενότητα "Εργαλεία", κάτω απο τις "Πληροφορίες Αγοράς" . Για να υπολογίσετε την ολονύκτια χρηματοδότηση με την οποία θα χρεωθεί ή θα πιστωθεί ο λογαριασμός σας, απλά πολλαπλασιάστε το ποσοστό ολονύκτιας χρηματοδότησης με το μέγεθος της συναλλαγής σας. Η ώρα εκτέλεσης της "Ολονύκτιας Χρηματοδότησης" για κάθε CFD αναφέρεται λεπτομερώς στις "Πληροφορίες Τίτλου" στο παράθυρο νέας συναλλαγής με τίτλο "Ολονύκτια Χρηματοδότηση (GMT)". Η υπολογιζόμενη αξία και το ποσοστό της Ολονύκτιας Χρηματοδότησης ενός τίτλου ισχύει για 1 ημέρα. Τα CFDs που διαπραγματεύονται 5 ημέρες την εβδομάδα θα πιστωθούν ή θα χρεωθούν 3 φορές την εμφανιζόμενη αξία κατά την τελευταία ημέρα της εβδομάδας για την συγκεκριμένη συναλλαγή, έτσι ώστε να καλύπτεται ολόκληρη η περίοδος του Σαββατοκύριακου. Το ποσό της Ολονύκτιας Χρηματοδότησης είναι αναφερόμενο στο νόμισμα στο οποίο εκφράζεται το CFD. Ωστόσο, εάν το νόμισμα του CFD διαφέρει από το νόμισμα του λογαριασμού, τότε το πρώτο θα μετατραπεί στο νόμισμα του λογαριασμού.
                  <br><br>
                  <u><b><u>Formula</u></b></u><br><br>
                  Υπολογισμός ποσοστού ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:
                      <br>
  
                    <div class="formula formula_f1">
                        <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">Επιτόκιο του άλλου νομίσματος - Επιτόκιο του βασικού νομίσματος + Πρόσθετο περιθώριο</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    Υπολογισμός ποσοστού ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">Επιτόκιο του άλλου νομίσματος - Επιτόκιο του βασικού νομίσματος - Μείωση Short</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      Για να υπολογίσετε το ποσό της ολονύκτιας χρηματοδότησης απλά πολλαπλασιάστε το σχετικό ποσοστό με το μέγεθος της συναλλαγής που αφορά:<br><br>Ολονύκτια χρηματοδότηση = Μέγεθος συναλλαγής X Ποσοστό ολονύκτιας χρηματοδότησης
                      <br><br><br>
                      <b><u><u>Παραδείγματα</u></u></b><br><br>
                      <b>Παράδειγμα I</b><br><br>
                    Αυτό το παράδειγμα αφορά μια περίπτωση όπου η διαφορά μεταξύ διατραπεζικών επιτοκίων είναι ΥΨΗΛΟΤΕΡΗ από την προσαύξηση. Σε αυτές τις περιπτώσεις, ο λογαριασμός σας θα χρεώνεται όταν ανοίγετε θέσεις αγοράς και θα πιστώσεται όταν ανοίγετε θέσεις πώλησης:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                        <li>Τίτλος = EUR/USD (Euro vs. US Dollar)</li>
                        <li>Επιτόκιο EUR (βασικό νόμισμα) (ετησιοποιημένο) = -0,37% = -0,0037</li>
                        <li>Επιτόκιο USD (άλλο νόμισμα) (ετησιοποιημένο) = 1,08% = 0,0108</li>
                        <li>Διαφορά διατραπεζικών επιτοκίων = 1.45% = 0.0145</li>
                        <li>Προσαύξηση θέσης αγοράς = 0.75% = 0.0075</li>
                        <li>Προσαύξηση θέσης πώλησης = 0.75% = 0.0075</li>
                        <li>Μέγεθος συναλλαγής εκδρασμένο στο δεύτερο νόμισμα = 106,550 USD (100,000 EUR στην τρέχουσα τιμή κλεισίματος 1.0655)</li>
                    </ul>
                    Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    Ποσό ολονύκτιας χρηματοδότησης = 106,550 × (-0.0000611) = -6.51 USD, που σημαίνει 6.51 USD χρέωση ανά ημέρα
                    <br><br><br>
                    Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    Ποσό ολονύκτιας χρηματοδότησης = 106,550 × 0.00001944 = 2.07 USD πίστωση ανά ημέρα
                    <br><br><br>
                    <b>Παράδειγμα II</b><br><br>
                    Αυτό το παράδειγμα αφορά μια περίπτωση όπου η διαφορά μεταξύ διατραπεζικών επιτοκίων είναι ΥΨΗΛΟΤΕΡΗ από την προσαύξηση και τα επίπεδα προσαύξησης μπορεί να διαφέρουν μεταξύ θέσεων αγοράς και θέσεων πώλησης. Σε αυτές τις περιπτώσεις, ο λογαριασμός σας θα χρεώνεται κάθε βράδυ ανεξαρτήτως της κατεύθυνσης της θέσης σας:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>Τίτλος = EUR/TRY (Ευρώ vs. Τουρκική Λίρα)</li>
                       <li>Επιτόκιο EUR (βασικό νόμισμα) (ετησιοποιημένο) = -0,37% = -0,0037</li>
                       <li>Επιτόκιο TRY (άλλο νόμισμα) (ετησιοποιημένο) = 22,75% = 0,2275</li>
                       <li>Διαφορά διατραπεζικών επιτοκίων = 23.12% = 0.2312</li>
                       <li>Προσαύξηση θέσης αγοράς = 0.75% = 0.0075</li>
                       <li>Προσαύξηση θέσης πώλησης = 14.00% = 0.14</li>
                       <li>Μέγεθος συναλλαγής εκδρασμένο στο δεύτερο νόμισμα = 620,000 TRY (100,000 EUR στην τρέχουσα τιμή κλεισίματος 6.2000)</li>
                    </ul>
                    Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        Ποσό ολονύκτιας χρηματοδότησης = 620,000 × (-0.000663) = -411 TRY, που σημαίνει 411 TRY χρέωση ανά ημέρα (≅80 USD)
                        <br><br><br>
                        Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        Ποσό ολονύκτιας χρηματοδότησης = 620,000 × 0.000253 = 157 TRY που σημαίνει 157 TRY χρέωση ανά ημέρα (≅30 USD)
                        <br><br><br>
                        <b>Παράδειγμα III</b><br><br>
                        Αυτό το παράδειγμα αφορά μια περίπτωση όπου η διαφορά μεταξύ των διατραπεζικών επιτοκίων είναι ΧΑΜΗΛΟΤΕΡΗ από την αρνητική προσαύξηση. Σε αυτές τις περιπτώσεις, ο λογαριασμός σας θα χρεώνεται όταν ανοίγετε θέσεις πώλησης και θα πιστώνεται όταν ανοίγετε θέσεις αγοράς:
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>Τίτλος = USD/JPY (US Dollar vs. Ιαπωνικό Γιέν)</li>
                           <li>Επιτόκιο USD (βασικό νόμισμα) (ετησιοποιημένο) = 1,08% = 1,08</li>
                           <li>Επιτόκιο JPY (άλλο νόμισμα) (ετησιοποιημένο) = -0,09% = -0,0009</li>
                           <li>Διαφορά διατραπεζικών επιτοκίων = -1.17% = -0.0117</li>
                           <li>Προσαύξηση θέσης αγοράς = 0.75% = 0.0075</li>
                           <li>Προσαύξηση θέσης πώλησης = 0.75% = 0.0075</li>
                           <li>Μέγεθος συναλλαγής εκδρασμένο στο δεύτερο νόμισμα = 10,341,000 JPY (100,000 USD στην τρέχουσα τιμή κλεισίματος 103.41)</li>
                        </ul>
                        Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        Ποσό ολονύκτιας χρηματοδότησης = 10,341,000 ×0.00001167=120.65 JPY πίστωση ανά ημέρα (≅1.1 USD)
                        <br><br><br>
                        Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        Ποσό ολονύκτιας χρηματοδότησης = 10,341,000 ×(-0.0000533)=-551.52 JPY, που σημαίνει 551.52 JPY χρέωση ανά ημέρα (≅5.3 USD)
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* Η επεξεργασία της ολονύκτιας χρηματοδότησης μπορεί να διαρκέσει έως και 15 λεπτά κατά το τέλος της ημέρας και στη συνέχεια ο λογαριασμός σας θα πιστωθεί ή θα χρεωθεί αναλόγως.</p>`,
          table_titles: [
            "Τίτλος",
            "Ποσοστό Ολονύκτιας Χρηματοδότησης (Πώληση)",
            "Ποσοστό Ολονύκτιας Χρηματοδότησης (Αγορά)",
            "Ολονύκτια Χρηματοδότηση (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "CFDs σε Δείκτες, Εμπορεύματα και Ψηφιακά Νομίσματα",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Ολονύκτια Χρηματοδότηση",
          content_before: `
              <p>Όταν κάνετε συναλλαγές CFDs δεικτών, εμπορευμάτων και κρυπτονομισμάτων με την iFOREX Europe, οι θέσεις που ανοίγετε υπόκεινται σε ολονύκτια χρηματοδότηση στο τέλος κάθε ημέρας. Αυτή η ολονύκτια χρηματοδότηση μπορεί να αφορά πίστωση ή χρέωση, η οποία υπολογίζεται βάσει των σχετικών επιτοκίων του νομίσματος στο οποίο συναλλάσεται ο υποκείμενος τίτλος, με μια επιπλέον προσαύξηση. Η προσαύξηση για τα κρυπτονομίσματα μπορεί να είναι σημαντικά υψηλότερη λόγω των ακραίων συνθηκών της αγοράς των Κρυπτονομισμάτων. Παρακαλούμε ανατρέξτε στον πιο κάτω πίνακα για τα πιο πρόσφατα ποσοστά ολονύκτιας χρηματοδότησης.
              <br><br>
              Εαν το αποτέλεσμα του υπολογισμού της ολονύκτιας χρηματοδότησης είναι θετικό αυτό σημαίνει ότι ένα συγκεκριμένο ποσό θα πιστωθεί στο υπόλοιπο του λογαριασμού σας. Μια αρνητική ολονύκτια χρηματοδότηση σημαίνει ότι ένα συγκεκριμένο ποσό θα αφαιρεθεί απο το υπόλοιπο του λογαριασμού σας.
              <br><br>
              Μπορείτε να βρείτε τα ποσοστά, τα ποσά και τα σχετικά ωράρια των ολονύκτιων χρηματοδοτήσεων τόσο στο παράθυρο "Νέας συναλλαγής" όσο και στο παράθυρο "Εντολής Ορίου", στην ενότητα "Εργαλεία", κάτω απο τις "Πληροφορίες Αγοράς" . Για να υπολογίσετε την ολονύκτια χρηματοδότηση με την οποία θα χρεωθεί ή θα πιστωθεί ο λογαριασμός σας, απλά πολλαπλασιάστε το ποσοστό ολονύκτιας χρηματοδότησης με το μέγεθος της συναλλαγής σας. Η ώρα εκτέλεσης της "Ολονύκτιας Χρηματοδότησης" για κάθε CFD αναφέρεται λεπτομερώς στις "Πληροφορίες Τίτλου" στο παράθυρο νέας συναλλαγής με τίτλο "Ολονύκτια Χρηματοδότηση (GMT)". Η υπολογιζόμενη αξία και το ποσοστό της Ολονύκτιας Χρηματοδότησης ενός τίτλου ισχύει για 1 ημέρα. Τα CFDs που διαπραγματεύονται 5 ημέρες την εβδομάδα θα πιστωθούν ή θα χρεωθούν 3 φορές την εμφανιζόμενη αξία κατά την τελευταία ημέρα της εβδομάδας για την συγκεκριμένη συναλλαγή, έτσι ώστε να καλύπτεται ολόκληρη η περίοδος του Σαββατοκύριακου. Το ποσό της Ολονύκτιας Χρηματοδότησης είναι αναφερόμενο στο νόμισμα στο οποίο εκφράζεται το CFD. Ωστόσο, εάν το νόμισμα του CFD διαφέρει από το νόμισμα του λογαριασμού, τότε το πρώτο θα μετατραπεί στο νόμισμα του λογαριασμού.
              <br><br>
              <u><b><u>Formula</u></b></u><br><br>
              Υπολογισμός ποσοστού ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Επιτόκιο + Πρόσθετο περιθώριο</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Υπολογισμός ποσοστού ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Επιτόκιο - Πρόσθετο περιθώριο</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                Για να υπολογίσετε το ποσό της ολονύκτιας χρηματοδότησης απλά πολλαπλασιάστε το σχετικό ποσοστό με το μέγεθος της συναλλαγής που αφορά:<br><br>Ολονύκτια χρηματοδότηση = Μέγεθος συναλλαγής X Ποσοστό ολονύκτιας χρηματοδότησης
                <br><br><br>
                <u><b><u>Παραδείγματα</u></b></u><br><br>
                <b>Παράδειγμα I</b><br><br>
                Αυτό το παράδειγμα αφορά μια περίπτωση όπου το διατραπεζικό επιτόκιο είναι ΥΨΗΛΟΤΕΡΟ απο την προσαύξηση. Σε αυτές τις περιπτώσεις, ο λογαριασμός σας θα χρεώνεται όταν ανοίγετε θέσεις αγοράς και θα πιστώσεται όταν ανοίγετε θέσεις πώλησης:
                <br><br>
                <ul class="list-style-dashed">
                   <li>Τίτλος = Brazil Ibovespa</li>
                   <li>Επιτόκιο Βραζιλιάνικου Ρεάλ (BRL) (ετησιοποιημένο) = 9,567% = 0,09567</li>
                   <li>Προσαύξηση = 2.5% = 0.025</li>
                   <li>Μέγεθος συναλλαγής εκφρασμένο σε νόμισμα = 127,380 BRL (2 συμβόλαια του δείκτη στην τρέχουσα τιμή κλεισίματος των 63690 BRL ανά συμβόλαιο)</li>
                </ul>
                <br>
                Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                Ποσό ολονύκτιας χρηματοδότησης = 127,380 × (-0.0003351944) = -42.70 BRL, που σημαίνει 42.70 BRL χρέωση ανά ημέρα (≅13.58 USD)
                <br><br><br>
                Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                Ποσό ολονύκτιας χρηματοδότησης = 127,380 × 0.00019630556 = 25 BRL πίστωση ανά ημέρα (≅7.95 USD)
                <br><br><br>
                <b>Παράδειγμα II</b><br><br>
                Αυτό το παράδειγμα αφορά μια περίπτωση όπου το διατραπεζικό επιτόκιο είναι ΧΑΜΗΛΟΤΕΡΟ απο την προσαύξηση. Σε αυτές τις περιπτώσεις, ο λογαριασμός σας θα χρεώνεται κάθε βράδυ ανεξαρτήτως της κατεύθυνσης της θέσης σας:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Τίτλος = Oil (Crude Light WTI)</li>
                   <li>Επιτόκιο Δολαρίου ΗΠΑ (USD) (ετησιοποιημένο) = 1,08% = 0,0108</li>
                   <li>Προσαύξηση = 2.5% = 0.025</li>
                   <li>Μέγεθος συναλλαγής εκφρασμένο σε νόμισμα = 53,250 USD (1,000 βαρέλια πετρελαίου στην τρέχουσα τιμή κλεισίματος των 53.25 USD ανά βαρέλι)</li>
                </ul>
           
                Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:
                  <br>
                  <br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    Ποσό ολονύκτιας χρηματοδότησης = 53,250 × (-0.00009944) = -5.30 USD, που σημαίνει 5.30 USD χρέωση ανά ημέρα
                    <br><br><br>
                    Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    Ποσό ολονύκτιας χρηματοδότησης = 53,250 × (-0.00003944) = -2.10 USD, που σημαίνει 2.10 USD χρέωση ανά ημέρα
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Η επεξεργασία της ολονύκτιας χρηματοδότησης μπορεί να διαρκέσει έως και 15 λεπτά κατά το τέλος της ημέρας και στη συνέχεια ο λογαριασμός σας θα πιστωθεί ή θα χρεωθεί αναλόγως.</p>`,
          table_titles: [
            "Τίτλος",
            "Ποσοστό Ολονύκτιας Χρηματοδότησης (Πώληση)",
            "Ποσοστό Ολονύκτιας Χρηματοδότησης (Αγορά)",
            "Ολονύκτια Χρηματοδότηση (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "Ημερομηνίες Εφαρμογής Rollover Συμβολαίων",
          content_before: `<p>
          Κάθε CFD το οποίο είναι βασισμένο σε συμβόλαιο future (π.χ. εμπορεύματα και δείκτες) έχει μια ημερομηνία εφαρμογής rollover.
          <br><br>
          Σε ημερομηνίες εφαρμογής rollover επενδυτικών τίτλων, όλες οι ανοικτές θέσεις σε CFD που βασίζονται σε συμβόλαια futures, θα γίνονται rolled-over στο επόμενο συμβόλαιο έτσι ώστε να παραμένουν ανοικτές με το νέο συμβόλαιο future.
          <br><br>
          Με την μετακύληση μιας θέσης, το ανοικτό P/L (Κέρδος/Ζημία) της θέσης θα επηρεαστεί απο τη διαφορά μεταξύ της τιμής του συμβολαίου που έχει λήξει και της τιμής του νέου συμβολαίου, συμπεριλαμβάνοντας μια προσαύξηση που ισοδυναμεί με το spread. Όλες οι σχετικές εντολές ορίων θα προσαρμοστούν σύμφωνα με την τιμή του νέου συμβολαίου.
          <br><br>
          Για παράδειγμα, εάν η τελευταία τιμή του συμβολαίου WTI για παράδοση το Φεβρουάριο ήταν στα $50.125 και η τιμή αγοράς του επόμενου συμβολαίου (Μαρτίου) την ίδια στιγμή ήταν στα $50.805, τότε τα επίπεδα τιμών όλων των ανοικτων εντολών ορίων θα είχαν μια ανοδική προσαρμογή κατά $0.68.
          <br><br>
          Οι ημερομηνίες εφαρμογής rollover συμβολαίων εξαρτούνται απο τον τίτλο στον οποίο κάνετε συναλλαγές, και πιο κάτω παρέχονται οι ημερομηνίες εφαρμογής rollover σε θέσεις CFD της iFOREX Europe:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Μήνας συμβολαίου", "Ημερομηνία και ώρα (GMT) εφαρμογής rollover συμβολαίων"],
          view_id: ["Commodity", "Index"],
          products: ["Εμπορεύματα", "Δείκτες"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "CFDs σε μετοχές και ETFs",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Ολονύκτια Χρηματοδότηση",
          content_before: `<p>Όταν κάνετε συναλλαγές σε Μετοχές και CFDs των ETF με την iFOREX Europe, οι θέσεις που ανοίγετε υπόκεινται σε ολονύκτια χρηματοδότηση στο τέλος κάθε ημέρας. Αυτή η ολονύκτια χρηματοδότηση μπορεί να αφορά πίστωση ή χρέωση, η οποία υπολογίζεται βάσει των σχετικών επιτοκίων του νομίσματος στο οποίο συναλλάσεται ο υποκείμενος τίτλος, με μια επιπλέον προσαύξηση. Παρακαλούμε ανατρέξτε στον πιο κάτω πίνακα για τα πιο πρόσφατα ποσοστά ολονύκτιας χρηματοδότησης.
          <br><br>
          Εαν το αποτέλεσμα του υπολογισμού της ολονύκτιας χρηματοδότησης είναι θετικό αυτό σημαίνει ότι ένα συγκεκριμένο ποσό θα πιστωθεί στο υπόλοιπο του λογαριασμού σας. Μια αρνητική ολονύκτια χρηματοδότηση σημαίνει ότι ένα συγκεκριμένο ποσό θα αφαιρεθεί απο το υπόλοιπο του λογαριασμού σας.
          <br><br>
          Μπορείτε να βρείτε τα ποσοστά, τα ποσά και τα σχετικά ωράρια των ολονύκτιων χρηματοδοτήσεων τόσο στο παράθυρο "Νέας συναλλαγής" όσο και στο παράθυρο "Εντολής Ορίου", στην ενότητα "Εργαλεία", κάτω απο τις "Πληροφορίες Αγοράς" . Για να υπολογίσετε την ολονύκτια χρηματοδότηση με την οποία θα χρεωθεί ή θα πιστωθεί ο λογαριασμός σας, απλά πολλαπλασιάστε το ποσοστό ολονύκτιας χρηματοδότησης με το μέγεθος της συναλλαγής σας. Η ώρα εκτέλεσης της "Ολονύκτιας Χρηματοδότησης" για κάθε CFD αναφέρεται λεπτομερώς στις "Πληροφορίες Τίτλου" στο παράθυρο νέας συναλλαγής με τίτλο "Ολονύκτια Χρηματοδότηση (GMT)". Η υπολογιζόμενη αξία και το ποσοστό της Ολονύκτιας Χρηματοδότησης ενός τίτλου ισχύει για 1 ημέρα. Τα CFDs που διαπραγματεύονται 5 ημέρες την εβδομάδα θα πιστωθούν ή θα χρεωθούν 3 φορές την εμφανιζόμενη αξία κατά την τελευταία ημέρα της εβδομάδας για την συγκεκριμένη συναλλαγή, έτσι ώστε να καλύπτεται ολόκληρη η περίοδος του Σαββατοκύριακου. Το ποσό της Ολονύκτιας Χρηματοδότησης είναι αναφερόμενο στο νόμισμα στο οποίο εκφράζεται το CFD. Ωστόσο, εάν το νόμισμα του CFD διαφέρει από το νόμισμα του λογαριασμού, τότε το πρώτο θα μετατραπεί στο νόμισμα του λογαριασμού.
          <br><br>
          <u><b><u>Formula</u></b></u><br><br>
          Υπολογισμός ποσοστού ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:
                  
                  <br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">Επιτόκιο + Πρόσθετο περιθώριο</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Υπολογισμός ποσοστού ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">Επιτόκιο - Πρόσθετο περιθώριο</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                Για να υπολογίσετε το ποσό της ολονύκτιας χρηματοδότησης απλά πολλαπλασιάστε το σχετικό ποσοστό με το μέγεθος της συναλλαγής που αφορά:<br><br>Ολονύκτια χρηματοδότηση = Μέγεθος συναλλαγής X Ποσοστό ολονύκτιας χρηματοδότησης
                <br><br><br>
                <u><b><u>Παραδείγματα</u></b></u><br><br>
                <b>Παράδειγμα I</b><br><br>
                Αυτό το παράδειγμα αφορά μια περίπτωση όπου το διατραπεζικό επιτόκιο είναι ΥΨΗΛΟΤΕΡΟ απο την προσαύξηση. Σε αυτές τις περιπτώσεις, ο λογαριασμός σας θα χρεώνεται όταν ανοίγετε θέσεις αγοράς και θα πιστώσεται όταν ανοίγετε θέσεις πώλησης:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>Τίτλος = Gazprom (GAZP)</li>
                   <li>Επιτόκιο Ρωσικού Ρουβλίου (RUB) (ετησιοποιημένο) = 9,5% = 0,095</li>
                   <li>Προσαύξηση = 5% = 0.05</li>
                   <li>Μέγεθος συναλλαγής εκφρασμένο σε νόμισμα = 2,459,000 RUB (20,000 Μετοχές στην τρέχουσα τιμή κλεισίματος των 122.95 RUB ανά μετοχή)</li>
                </ul>
      
                Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                Ποσό ολονύκτιας χρηματοδότησης = 2,459,000 × (-0.0004) = -983.60 RUB, που σημαίνει 983.60 RUB χρέωση ανά ημέρα (≅17.52 USD)
                <br><br><br>
                Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Ποσό ολονύκτιας χρηματοδότησης = 2,459,000 × 0.000125 = 307.38 RUB πίστωση ανά ημέρα (≅5.48 USD)
                <br><br><br>
                <b>Παράδειγμα II</b><br><br>
                Αυτό το παράδειγμα αφορά μια περίπτωση όπου το διατραπεζικό επιτόκιο είναι ΧΑΜΗΛΟΤΕΡΟ απο την προσαύξηση. Σε αυτές τις περιπτώσεις, ο λογαριασμός σας θα χρεώνεται κάθε βράδυ ανεξαρτήτως της κατεύθυνσης της θέσης σας:
                <br><br>
                <ul class="list-style-dashed">
                    <li>Τίτλος = Apple (AAPL)</li>
                    <li>Επιτόκιο Δολαρίου ΗΠΑ (USD) (ετησιοποιημένο) = 1,08% = 0,0108</li>
                    <li>Προσαύξηση = 5% = 0.05</li>
                    <li>Μέγεθος συναλλαγής εκφρασμένο σε νόμισμα = 70,600 USD (500 μετοχές στην τρέχουσα τιμή κλεισίματος 141.20 USD ανά μετοχή)</li>
                </ul>
                <br>
                Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις αγοράς:<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                Ποσό ολονύκτιας χρηματοδότησης = 70,600 × (-0.000169) = -11.93 USD, που σημαίνει 11.93 USD χρέωση ανά ημέρα
                <br><br><br>
                Ποσοστό ολονύκτιας χρηματοδότησης σε θέσεις πώλησης:<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Ποσοστό ολονύκτιας χρηματοδότησης</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>
                Ποσό ολονύκτιας χρηματοδότησης = 70,600 × (-0.000109) = -7.70 USD, που σημαίνει 7.70 USD χρέωση ανά ημέρα
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Η επεξεργασία της ολονύκτιας χρηματοδότησης μπορεί να διαρκέσει έως και 15 λεπτά κατά το τέλος της ημέρας και στη συνέχεια ο λογαριασμός σας θα πιστωθεί ή θα χρεωθεί αναλόγως.</p>`,
          table_titles: [
            "Τίτλος",
            "Ποσοστό Ολονύκτιας Χρηματοδότησης (Πώληση)",
            "Ποσοστό Ολονύκτιας Χρηματοδότησης (Αγορά)",
            "Ολονύκτια Χρηματοδότηση (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Κατανομή Μερισμάτων",
          content_before: `<p>
                        Σε περίπτωση κατανομής μερισμάτων σε μετρητά που σχετίζονται με ένα CFD μετοχής, η προσαρμογή του μερίσματος θα γίνει στο Υπόλοιπο του Πελάτη ανάλογα με τις τις θέσεις που διατηρεί ο Πελάτης στη συγκεκριμένη μετοχή στο τέλος της εργάσιμης ημέρας που προηγείται της ημερομηνίας κατανομής μερισμάτων. Η προσαρμογή μερισμάτων υπολογίζεται με βάση το μέγεθος του μερίσματος, το μέγεθος της θέσης του πελάτη και κατά πόσον πρόκειται για αγορά ή πώληση, ως εκ τούτου, σε θέσεις αγοράς η προσαρμογή θα πιστώνεται στο υπόλοιπο του Πελάτη και σε θέσεις πώλησης, η προσαρμογή θα χρεώνεται από το Υπόλοιπο του πελάτη. Τα μερίσματα θα πιστώνονται ή χρεώνονται στο Υπόλοιπο του Πελάτη εκτός του ωραρίου συναλλαγών της υποκείμενης μετοχής και πριν από την έναρξη της επόμενης ημέρας συναλλαγών της μετοχής, και εξαρτώνται από το αν ο Πελάτης διατηρεί την αντίστοιχη Θέση κατά τη στιγμή της προσαρμογής μερισμάτων. Κατά τη διάρκεια αυτής της περιόδου, προκειμένου να διατηρηθεί η εύλογη αξία των Ιδίων Κεφαλαίων του Πελάτη, μέχρι την έναρξη της επόμενης ημέρας συναλλαγών, η Εταιρεία προσαρμόζει τη θέση του Πελάτη, σύμφωνα με το ποσό του μερίσματος που χρεώνεται ή πιστώνεται από το Υπόλοιπο του Πελάτη.
                        <br><br>
                        <u>Παράδειγμα</u>:<br>
                        H Coca-Cola εκδίδει μέρισμα 0.35 σέντ του δολαρίου ανά μετοχή.<br>
                        Η ημερομηνία κατανομής μερισμάτων είναι η 29η Νοεμβρίου και η ημερομηνία διακανονισμού της iFOREX Europe είναι η 28η Νοεμβρίου στις 22:05 GMT.<br>
                        Η τιμή κλεισίματος πρίν το διακανονισμό είναι το 41.65.<br>
                        Ενας πελάτης ο οποίος διατηρεί μια θέση Αγοράς 5000 μετοχών θα πιστωθεί με 0.35 x 5000 - 1750 δολάρια, εάν η συναλλαγή του είναι ανοικτή την ημερομηνία διακανονισμού.
                        <br>
                        Ένα παρόμοιο ποσό θα χρεωθεί απο το υπόλοιπο ενός πελάτη ο οποίος διατηρεί μια θέση Πώλησης.
                        <br>
                        Η τιμή της μετοχής θα προσαρμοστεί απο το 41.65 στο 41.30 έτσι ώστε να αντανακλά την τελευταία τιμή της μετοχής μείον το ποσό του μερίσματος.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"Προς το παρόν δεν υπάρχουν πληροφορίες για μελλοντική διανομή μερισμάτων",
          table_titles: [
            "Μετοχή / ETF",
            "Market",
            "Ποσό Μερίσματος",
            "Ημερομηνία και Ωρα (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Κατανομή Μερίσματος Μετοχών, Διασπάσεις Μετοχών και άλλες Εταιρικές Ενέργειες",
          content_before: `<p>
          Οι Εταιρικές Πράξεις είναι ορισμένα γεγονότα τα οποία επηρεάζουν την αξία των μετοχών μιας δημόσιας εταιρείας. Εκτός αν αναφέρεται διαφορετικά στο παρόν, όσον αφορά συγκεκριμένες εταιρικές πράξεις, με την εμφάνιση μιας εταιρικής πράξης σε μια συγκεκριμένη μετοχή, η iFOREX Europe θα προχωρήσει στη ρευστοποίηση κάθε ανοιχτής θέσης στα αντίστοιχα CFD καθώς και όπου απαιτείται, στην κατάργηση οποιωνδήποτε εντολών ορίων στα εν λόγω CFD.
          <br><br>
          Οι Εταιρικές Πράξεις της iFOREX Europe περιλαμβάνουν την προσφορά δικαιωμάτων τη Διαγραφή και κάθε άλλο γεγονός που επηρεάζει ουσιωδώς ή ενδέχεται να επηρεάσει ουσιωδώς την τιμή μιας μετοχής (συμπεριλαμβανομένων των ουσιωδών ανακοινώσεων της εταιρείας, εξαγορών, συγχωνεύσεων, πτώχευσης κλπ).
          <br><br>

          <b>Κατανομή Μερίσματος Μετοχών</b><br>

            Η κατανομή μερίσματος μετοχών στο χρηματιστήριο δεν αλλάζει τη συνολική αξία των μετοχών για όσους τις κατέχουν, αλλά αλλάζει τον αριθμό των μετοχών και την τιμή τους.<br>
            Θα λάβετε τον «Συντελεστή Προσαρμογής» για κάθε μετοχή που κατέχετε.<br>
            Οποιαδήποτε από τις ανοιχτές σας συναλλαγές ή/και εντολές ορίου κατά την ημερομηνία και ώρα κατανομής μερίσματος μετοχών θα προσαρμοστεί ανάλογα ως προς το ποσό, την τιμή και τις σχετικές εντολές (συμπεριλαμβανομένου του υπολοίπου λογαριασμού λόγω απαιτούμενων προσαρμογών Κέρδους/Ζημιάς, εφόσον ισχύει).<br>
            Για παράδειγμα, σε Προσαρμογή Μετοχών με συντελεστή προσαρμογής 1,8, τότε 1 μετοχή γίνεται 1,8 μετοχές μετά το γεγονός και η τιμή διαιρείται με 1,8, αφήνοντας τη συνολική αξία των μετοχών αμετάβλητη.<br>
            Π.χ., 1 μετοχή με τιμή $1.000 θα γίνει 1,8 μετοχές με τιμή $555,56 μετά το γεγονός: 1×$1.000 = 1,8×$555,56 = $1.000 αξία.<br><br>


          <strong>
          Ειδικοί κανόνες για τις διασπάσεις μετοχών και τις αντίστροφες διασπάσεις μετοχών
          </strong>
          <br>
          Οι διασπάσεις μετοχών και οι αντίστροφες διασπάσεις μετοχών στο χρηματιστήριο δεν μεταβάλλουν τη συνολική αξία των μετοχών για όσους τις κατέχουν, ωστόσο, μεταβάλλουν τον αριθμό των μετοχών και την τιμή τους. Οι διασπάσεις αυτές πραγματοποιούνται συνήθως όταν η τιμή της μετοχής είναι είτε πολύ υψηλή είτε πολύ χαμηλή. Σε περίπτωση που μια ανοικτή συναλλαγή/όριο υποστεί διάσπαση μετοχών, το ποσό της, η τιμή και το σχετικό επίπεδο ορίου/ορίων θα προσαρμοστούν αναλόγως. (συμπεριλαμβανομένου του υπολοίπου του λογαριασμού, λόγω των απαιτούμενων προσαρμογών κέρδους/ζημιάς, κατά περίπτωση).
          <br><br>
          Για παράδειγμα, σε μια διάσπαση 1:10, 1 μετοχή μετατρέπεται σε 10 μετοχές μετά την εταιρική πράξη και η τιμή διαιρείται διά 10, αφήνοντας τη συνολική αξία των μετοχών αμετάβλητη. Π.χ., 1 μετοχή με τιμή 1.000 δολάρια θα γίνει 10 μετοχές με τιμή 100 δολάρια ανά μετοχή μετά την εταιρική πράξη: 1x $1.000 = 10 x$100 = αξία $1.000.
          <br><br>
          Πιο κάτω μπορείτε να δείτε τη λίστα με τις επερχόμενες Εταιρικές Πράξεις:
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"δεν υπάρχουν πληροφορίες για μελλοντικές Εταιρικές Πράξεις",
          table_titles: ["Μετοχή / ETF", "Market", "Type", "Ημερομηνία και Ωρα (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Ανακοινώσεις Εταιρικών Κερδών",
          content_before: `<p>
                          Η ανακοίνωση εταιρικών κερδών είναι μία δημοσίευση που γίνεται από δημόσιες εταιρίες για να αναφέρουν την επίδοσή τους. Αναλύοντας τα εταιρικά κέρδη του τριμήνου, οι επενδυτές μπορούν να αναλύσουν την οικονομική ευημερία της εταιρίας. Η ανακοίνωση κερδών μίας εταιρίας, ειδικά μίας δημοφιλούς εταιρίας με υψηλή κεφαλοποίηση στη αγορά, μπορεί να επηρεάσει τις τιμές των μετοχών της, προκαλώντας τους μεγάλες διακυμάνσεις τις ημέρες οπού ανακοινώνονται τα κέρδη του τριμήνου.
                          <br><br>
                          Γι' αυτό το λόγο, η μέγιστη έκθεση των σχετικών μετοχών θα μειωθεί στις 10.000 δολάρια καθ' όλη τη διάρκεια της περιόδου δημοσίευσης.
                          </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  